/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Students_AddInputs */

const en_students_add = /** @type {(inputs: Students_AddInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add student`)
};

const he_students_add = /** @type {(inputs: Students_AddInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`הוספת תלמיד`)
};

/**
* | output |
* | --- |
* | "Add student" |
*
* @param {Students_AddInputs} inputs
* @param {{ locale?: "en" | "he" }} options
* @returns {LocalizedString}
*/
export const students_add = /** @type {((inputs?: Students_AddInputs, options?: { locale?: "en" | "he" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Students_AddInputs, { locale?: "en" | "he" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_students_add(inputs)
	return he_students_add(inputs)
});